<template>
  <div class="app_list_wrapper">
    <div class="app_wrapper_cla" :key="index" v-for="(item, index) in appItem">
      <div class="app-item-card">
        <div class="app-card-head-cla">
          <div class="app-title-cla">
            <div class="head_name">{{ item.name }}</div>
            <div class="middle_cla">
              <i
                class="el-icon-delete"
                v-if="hasPermission('8ab6a159ba4440c0b942f0f1e0e3f1b2')"
                style="margin-left:10px;color:#f56c6c;cursor: pointer;"
                @click="deleteApp(item)"
              ></i>
            </div>
          </div>
          <div class="app_desc">
            <span v-if="item.des">{{ item.des }}</span>
          </div>
          <div class="appkey">
            <span class="font_AppKey_color">AppKey:{{ item.appKey }}</span>
          </div>
        </div>

        <div class="app-info-cla">
          <div class="info-item-cla">
            <div class="info-label-cla">{{ $t('developer.deviceTotle') }}</div>
            <div class="font">{{ item.deviceNum }}</div>
          </div>
          <div class="info-item-cla">
            <div class="info-label-cla">{{ $t('developer.companyNum') }}</div>
            <div class="font">{{ item.companyNum }}</div>
          </div>
        </div>

        <!-- 最近活跃时间 -->
        <div class="livelyTime-cla">
          <label>{{ $t('developer.lastQuest') }}：</label>
          <span v-if="item.livelyTime">{{ item.livelyTime | dataFormat }}</span>
          <span v-else>N/A</span>
        </div>
        <div class="createdDate-cla">
          <label>{{ $t('common.createdDate') }}：</label>
          <span>{{ (item.createdDate * 1000) | dataFormat }}</span>
        </div>

        <div class="foot-btn-cla">
          <div class="enter-app-cla" @click="enterApp(item)">
            {{ $t('developer.enterApp') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    appList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  computed: {
    appItem() {
      return this.appList
    }
  },

  methods: {
    editApp(item) {
      this.$emit('editApp', item)
    },
    enterApp(item) {
      this.$emit('enterApp', item)
    },
    deleteApp(item) {
      this.$emit('deleteApp', item)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
.app_list_wrapper {
  display: flex;
  flex-wrap: wrap;
}
.app_wrapper_cla {
  width: 33.32%;
  padding-bottom: 12px;
  box-sizing: border-box;
  .app-item-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    border-radius: 2px;
    height: 100%;
    .app-card-head-cla {
      padding: 15px 20px;
      background: #f8fcf8;
      border-radius: 1px 1px 0 0;
    }
    .app-title-cla {
      display: flex;
      justify-content: space-between;
    }
    .font-base-cla {
      height: 20px;
      line-height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.4);
      letter-spacing: 0;
    }
    .app_desc {
      .font-base-cla;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-height: 12px;
    }
    .appkey {
      .font-base-cla;
    }

    .app-info-cla {
      display: flex;
      justify-content: space-around;
      text-align: center;
      margin-top: 12px;
      .info-item-cla {
        width: 50%;
        .info-label-cla {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.9);
          letter-spacing: 0;
          text-align: center;
        }
        .font {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: @themeColor;
          letter-spacing: 0;
          text-align: center;
          margin-top: 8px;
          height: 25px;
          line-height: 25px;
        }
      }
    }

    .font_AppKey_color {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      letter-spacing: 0;
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 100%;
    }

    .font_color {
      .font_AppKey_color;
      margin-left: 20px;
      font-size: 14px;
      label {
        color: rgba(0, 0, 0, 0.4);
      }
      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .createdDate-cla {
      .font_color;
      margin-top: 8px;
    }

    .livelyTime-cla {
      .font_color;
      margin-top: 12px;
    }

    .foot-btn-cla {
      display: flex;
      padding: 16px 20px;
      justify-content: flex-end;
      .enter-app-cla {
        height: 32px;
        line-height: 32px;
        padding: 0px 16px;
        background-color: @themeColor;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        border-radius: 16px;
        cursor: pointer;
      }
    }
  }
}

.app_wrapper_cla:nth-child(3n-1) {
  padding-right: 4px;
  padding-left: 4px;
}
.app_wrapper_cla:nth-child(3n + 1) {
  padding-right: 8px;
}
.app_wrapper_cla:nth-child(3n) {
  padding-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appList/itemCard.vue